import styled from "styled-components";
import { motion } from "framer-motion";

export const TopContainerP5 = styled.div`
  width: 100%;
  height: 80px;
  background-color: var(--color-white);
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: sticky;
  top: 0;
  h1 {
    font-size: 18px;
    margin: 10px;
    font-weight: 500;
  }
`;

export const ContainerP5 = styled(motion.div)`
  width: 100%;
  height: calc(100dvh - 8dvh);
  position: relative;
  .linear-separation {
    background: linear-gradient(
      180deg,
      #c4c4c4 0%,
      rgba(196, 196, 196, 0) 100%
    );
    width: 100%;
    height: 4px;
    mix-blend-mode: multiply;
    opacity: 0.25;
  }
`;

export const BodyContainerP5 = styled.div`
  width: 100%;
  height: calc(100dvh - 182px);
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-y: scroll;
  overflow-x: hidden;
  position: relative;
  gap: 50px;
  padding: 10px 20px 50px 20px;
  .txtTurno {
    text-align: center;
  }
  z-index: 1;
  margin-top: 30px;
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const IconsBox = styled.div`
  display: flex;
  gap: 30px;
  align-items: center;
  justify-content: center;
  width: 100%;
  .icons-box-title {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
  }
`;

export const EstudiosContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding-left: 20%;
`;

export const EstudioBox = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  width: 100%;
`;

export const ButtonP5 = styled.button`
  width: 250px;
  height: 39px;
  background: var(--color-primary);
  font-size: 16px;
  color: var(--color-white);
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: auto;
  margin-top: 10px;
`;
